module.exports = __webpack_public_path__ + "static/media/socials-graphic.0a1f1d79.svg";